<button
  #pauseButton
  class="player-play-control__play-button sn-player__button"
  type="button"
  (click)="pause()"
>
  <sn-icon>pause</sn-icon>
</button>
<button
  #replayButton
  class="player-play-control__play-button sn-player__button"
  type="button"
  (click)="play()"
>
  <sn-icon>replay</sn-icon>
</button>
<button
  #playButton
  class="player-play-control__play-button sn-player__button"
  type="button"
  (click)="play()"
> 
  <sn-icon>play_arrow</sn-icon>
</button>
